import React from 'react';
import { Row, Col, Input, Collapse, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { onGetNewRelicTransactionByAPM as onGetNewRelicTransactionByAPM } from '../../store/actions'
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const NewrelicResourceactions = (props) => {
    const {
        selectedPage,
        total_resources,
        itemsPerPage,
        handlePageClick,
        isOpen,
        toggle,
        setSearch,
        startDate,
        endDate,
        handleStartDateChange,
        handleEndDateChange,
        toggleDates,
        isDateOpen,
        handlePredefinedDateChange,
    } = props;

    const totalPages = Math.ceil(total_resources / itemsPerPage);
    let startPage = Math.max(selectedPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage === totalPages) {
        startPage = Math.max(totalPages - 2, 1);
    }
    const dispatch = useDispatch()
    const params = useParams()
    const handleRadioChange = (event) => {
        if (event && event.target) {
            const value = event.target.value;
            if (value === 'last1Day') {
                handlePredefinedDateChange(1);
            } else if (value === 'last3Days') {
                handlePredefinedDateChange(3);
            } else if (value === 'last7Days') {
                handlePredefinedDateChange(7);
            } else if (value === 'last30Days') {
                handlePredefinedDateChange(30);
            }
        }
    };

    const handleRadioClick = (event) => {
        if (isDateOpen) {
            toggleDates();
        }
        handleRadioChange(event);
    };

    const handleClearFilters = (e) => {
        e.preventDefault(); 
        let resourceId = params.resourceId
        let pageFilters = { 'apm_monitored_resource_id': resourceId }
        setSearch({ target: { value: "" } })
        handleStartDateChange({ target: { value: "" } });
        handleEndDateChange({ target: { value: "" } });
        handlePageClick(1)
        dispatch(onGetNewRelicTransactionByAPM(pageFilters))
        toggle()
    };

    return (
        <>
            <Row className="mb-3">
                <Col md="2">
                    <div className="position-relative hstack gap-3">
                        <a href="#" onClick={toggle} className="btn btn-secondary w-100">
                            <i className="bx bx-filter-alt align-middle"></i> Search & Filter
                        </a>
                    </div>
                </Col>
                <Col md="8">
                </Col>
                <Col md="2">
                    <Pagination aria-label="pagination navigation" listClassName="justify-content-end pagination-rounded" className="mb-3">
                        {totalPages > 1 && (
                            <PaginationItem disabled={selectedPage === 1}>
                                <PaginationLink previous onClick={() => handlePageClick(selectedPage - 1)} />
                            </PaginationItem>
                        )}
                        {[...Array(endPage - startPage + 1)].map((_, index) => (
                            <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                                <PaginationLink onClick={() => handlePageClick(startPage + index)}>
                                    {startPage + index}
                                </PaginationLink>
                            </PaginationItem>
                        ))}
                        {totalPages > 1 && (
                            <PaginationItem disabled={selectedPage === totalPages}>
                                <PaginationLink next onClick={() => handlePageClick(selectedPage + 1)} />
                            </PaginationItem>
                        )}
                    </Pagination>
                </Col>
            </Row>
            <Collapse isOpen={isOpen} id="filterCollapse">
                <Row>
                    <Row className="mb-3">
                        <Col md="1">
                            <label htmlFor="search-input" className="col-md-12 col-form-label">
                                Search:
                            </label>
                        </Col>
                        <Col md="2" lg={2}>
                            <Input
                                name="search"
                                className="form-control"
                                placeholder="Search: Name"
                                type="string"
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3 align-items-baseline">
                        <Col md={1} lg={1}>
                            <label htmlFor="search-input" className="col-md-12 col-form-label">
                                Created in:
                            </label>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last1Day"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    1 day
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last3Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    3 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last7Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    7 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="last30Days"
                                    onClick={handleRadioClick}
                                />
                                <label className="form-check-label">
                                    30 days
                                </label>
                            </div>
                        </Col>
                        <Col md={1} lg={1}>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="dates-radio"
                                    id="dates-radio"
                                    value="option1"
                                    onClick={toggleDates}
                                />
                                <label className="form-check-label">
                                    Custom
                                </label>
                            </div>
                        </Col>
                        <Col md={4} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <div className="row">
                                <div className="col">
                                    <button type="button" className="btn btn-primary w-md justify-content-end" style={{marginRight:10}} onClick={() => handlePageClick(1)}>
                                        Search
                                    </button>
                                    <button className="btn btn-secondary justify-content-start" onClick={(e) => handleClearFilters(e)}>
                                        Clear Filters
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Collapse isOpen={isDateOpen} id="filterDateCollapse">
                        <Row className="mb-3">
                            <Col md={2} lg={2}>
                                <label htmlFor="from-date-input" className="col-md-12 col-form-label">
                                    Created Date(from):
                                </label>
                            </Col>
                            <Col md={3} lg={3}>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder='From'
                                    id="from-date-input"
                                    value={startDate ? startDate.toISOString().split('T')[0] : ''}
                                    onChange={handleStartDateChange}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md={2} lg={2}>
                                <label htmlFor="to-date-input" className="col-md-12 col-form-label">
                                    Created Date(to):
                                </label>
                            </Col>
                            <Col md={3} lg={3}>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder='To'
                                    id="to-date-input"
                                    value={endDate ? endDate.toISOString().split('T')[0] : ''}
                                    onChange={handleEndDateChange}
                                />
                            </Col>
                        </Row>
                    </Collapse>
                </Row>
            </Collapse>
        </>
    );
};

export default NewrelicResourceactions;
